// @ts-nocheck
import { TrackJS } from "trackjs";

import router from "@/router";
import ls from "@/services/local-storage";
import { useAuthStore } from "@/stores/auth.store";
interface AuthHeader {
  Authorization: string;
}
interface AuthError {
  headers: AuthHeader;
  config?: {
    headers: AuthHeader;
  };
  response?: {
    headers: AuthHeader;
    config: {
      headers: AuthHeader;
    };
  };
}
const removeAuthorizationHeader = (headers: AuthHeader): void => {
  if (Object.prototype.hasOwnProperty.call(headers, "Authorization")) {
    delete headers.Authorization;
  }
};

const getErrorInfo = (error: AuthError): AuthError => {
  const errorCopy = { ...error };
  if (
    errorCopy.config &&
    Object.prototype.hasOwnProperty.call(
      errorCopy.config.headers,
      "Authorization"
    )
  ) {
    removeAuthorizationHeader(errorCopy.config.headers);
  }
  if (errorCopy.response) {
    removeAuthorizationHeader(errorCopy.response.headers);
    removeAuthorizationHeader(errorCopy.response.config.headers);
    return errorCopy.response;
  }
  return errorCopy.config ? errorCopy.config : errorCopy;
};

export default (error: AuthError): Promise<AuthError> => {
  if (
    error.response?.status === 401 &&
    router.currentRoute.value.name !== "login"
  ) {
    ls.clearToken();
    useAuthStore().clearLoggedIn();
    router.replace({ name: "login", query: { session_expired: "true" } });
  }
  const errorInfo = getErrorInfo(error);
  TrackJS.console.log(errorInfo);
  return Promise.reject(error);
};
